import React from "react";
import type { TrialInvite } from "../../../services/trialInviteApi";
import type { RevokeFailure } from "./useTrialInvites";
import { inviteContext } from "./inviteContext";

interface RevokeFeedbackProps {
  /** The invite revoked by the last successful request. */
  revoked: TrialInvite | null;
  failure: RevokeFailure | null;
  onRetry: () => void;
}

/** Outcome of the last "Odwołaj" — success is announced, failure is an alert. */
const RevokeFeedback: React.FC<RevokeFeedbackProps> = ({
  revoked,
  failure,
  onRetry,
}) => (
  <>
    {/* Always mounted so screen readers announce the text when it appears. */}
    <p
      aria-live="polite"
      className={revoked ? "text-sm text-green-800" : "sr-only"}
    >
      {revoked
        ? `Zaproszenie ${inviteContext(revoked)} odwołane — link już nie działa.`
        : ""}
    </p>
    {failure && (
      <div
        role="alert"
        className="flex flex-wrap items-center justify-between gap-2 px-4 py-3 rounded-lg bg-red-50 border border-red-200 text-sm text-red-800"
      >
        <span>{failure.message}</span>
        {failure.retryable && (
          <button
            type="button"
            onClick={onRetry}
            className="px-3 py-1 border border-red-300 rounded-md bg-white hover:bg-red-100"
          >
            Ponów odwołanie
          </button>
        )}
      </div>
    )}
  </>
);

export default RevokeFeedback;
